import isEmpty from 'lodash/isEmpty'

export const getTags = state => state.tags
export const getCategoryTags = state => state.categoryTags
export const getAuth = state => state.auth
export const isLoggedIn = state =>
  !isEmpty(getAuth(state).header) && getAuth(state).email
export const getOpportunites = state => state.opportunities
export const getOpportunity = state => state.opportunity
export const getOpportunityById = ({ state, id }) => getOpportunity(state).item
export const getMarkets = state => state.markets
export const getUseCases = state => state.useCases
export const getOrganization = state => state.organization
export const getVerticals = state => state.verticals
export const postVipForm = state => state.vip



// WEBPACK FOOTER //
// ./src/selectors/index.js